import { Component, inject } from '@angular/core';
import { FomoService } from '../../../../libs/services/fomo.service';

@Component({
  selector: 'app-fomo-bottom-bar',
  templateUrl: './fomo-bottom-bar.component.html',
  styleUrl: './fomo-bottom-bar.component.css',
})
export class FomoBottomBarComponent {
  private fomoService = inject(FomoService);

  count = this.fomoService.count;
}
